var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.9987H2.33333M2.33333 3.9987H13M2.33333 3.9987V13.332C2.33333 13.6857 2.47381 14.0248 2.72386 14.2748C2.97391 14.5249 3.31304 14.6654 3.66667 14.6654H10.3333C10.687 14.6654 11.0261 14.5249 11.2761 14.2748C11.5262 14.0248 11.6667 13.6857 11.6667 13.332V3.9987H2.33333ZM4.33333 3.9987V2.66536C4.33333 2.31174 4.47381 1.9726 4.72386 1.72256C4.97391 1.47251 5.31304 1.33203 5.66667 1.33203H8.33333C8.68696 1.33203 9.02609 1.47251 9.27614 1.72256C9.52619 1.9726 9.66667 2.31174 9.66667 2.66536V3.9987M5.66667 7.33203V11.332M8.33333 7.33203V11.332",
    stroke: "#E84140",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.740a6c5da57a7da8b16cd91981d2b943.svg";
export { ForwardRef as ReactComponent };